<template>
  <LazyHomeCommonLayout :is-blog-banner="true">
    <template #content>
      <section id="blog" class="blog subPageSection">
        <div class="backBg"></div>
        <div class="containerMain">
          <div class="cardList blogList">
            <div class="subPageTitle">
              <h1>{{ t("home-news-title") }}</h1>
            </div>
            <section class="listTopArea">
              <div class="listCount">
                <span>{{ newsPage.totalElementCount.toString().padStart(2, '0') }}</span>
                {{ t("home-news-count", newsPage.totalElementCount) }}
              </div>
            </section>
            <section v-if="isInit" class="cardListArea">
              <template v-if="newsList.length > 0">
                <ul class="cardListWrap">
                  <LazyNewsCard v-for="(news, index) in newsList" :key="index" :news="news"/>
                </ul>
                <div v-if="!newsPage.last" class="loadBtn" @click.stop="getArticleList()" @dblclick.prevent>{{ t("common-load-more") }}</div>
              </template>
              <div v-else class="listNone">{{ t("home-news-none") }}</div>
            </section>
          </div>
        </div>
      </section>
      <div id="mainFooter"></div>
      <!-- pc 네비게이션 펼칠 때 on 클래스 -->
    </template>
  </LazyHomeCommonLayout>
</template>

<script setup lang="ts">
import {onMounted, ref} from 'vue';
import {useI18n} from 'vue-i18n';
import {useHomeService} from '~/composables/service/useHomeService';
import {ArticleModel} from '~~/package/mapper/home/model/ArticleModel';
import {PageModel} from '~~/package/mapper/common/model/PageModel';
import {RouteName} from '~~/package/enum/RouteName';
import {useSeoMeta} from '~/composables/useSeoMeta';

const { $i18n } = useNuxtApp();
const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const homeService = useHomeService();
const { getCanonical, getHreflangLinks } = useSeoMeta();

const newsList = ref<ArticleModel[]>([]);
const newsPage = ref<PageModel<ArticleModel>>(new PageModel<ArticleModel>());
const isInit = ref(false);

useHead({
  title: '코드프레소 뉴스룸 | 보도자료·파트너십·수상 소식',
  meta: [
    { name: 'description', content: '코드프레소의 AI 역량 진단·교육, 신규 서비스, 파트너십, 수상 및 주요 언론 보도 소식을 확인하세요.' },
    { name: 'robots', content: 'index,follow' },
    { property: 'og:title', content: '코드프레소 뉴스룸 | 보도자료·파트너십·수상 소식' },
    { property: 'og:description', content: '코드프레소의 AI 역량 진단·교육, 신규 서비스, 파트너십, 수상 및 주요 언론 보도 소식을 확인하세요.' },
    { property: 'og:locale', content: 'ko_KR' },
  ],
  link: [...getHreflangLinks.value, { rel: 'canonical', href: getCanonical.value }],
})

definePageMeta({
  alias: [
    '/en/home/news',
    '/ja/home/news',
    '/ko/home/news',
    '/vi/home/news',
  ],
})

const getArticleList = () => {
  homeService
    .getArticleList(newsPage.value.pageNumber + 1, 9, "NEWS", $i18n.locale.value.toUpperCase())
    .then((page) => {
      newsList.value = [...newsList.value, ...page.data];
      newsPage.value = page;
      isInit.value = true;
    });
};

// 구 버전 페이지 링크 처리 (url 쿼리 존재 시)
const handleOldPageLink = () => {
  homeService
    .getArticle({ link: route.query.url as string })
    .then((articleData) => {
      router.replace({ name: RouteName.HomeBlogDetail, params: { newsId: articleData.id } });
    })
    .catch(() => {
      getArticleList();
      router.replace({ ...route, query: {} });
    });
};

onMounted(() => {
  if (route.query.url) {
    handleOldPageLink();
  } else {
    getArticleList();
  }
});
</script>

<style>
@import "~/assets/scss/blog_style.scss";
</style>